export enum CollectionTypes {
  USERS = "users",
  ONE_TO_ONE_CHATS_MESSAGES = "oneToOneChatsMessages",
  GROUP_CHATS_MESSAGES = "groupChatsMessages",
  MESSAGES = "messages",
  CHATS = "chats",
}
